import { render, staticRenderFns } from "./user-profile.vue?vue&type=template&id=0dc58f81&scoped=true"
import script from "./user-profile.vue?vue&type=script&lang=ts"
export * from "./user-profile.vue?vue&type=script&lang=ts"
import style0 from "./user-profile.vue?vue&type=style&index=0&id=0dc58f81&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc58f81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc58f81')) {
      api.createRecord('0dc58f81', component.options)
    } else {
      api.reload('0dc58f81', component.options)
    }
    module.hot.accept("./user-profile.vue?vue&type=template&id=0dc58f81&scoped=true", function () {
      api.rerender('0dc58f81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/layout/user-profile.vue"
export default component.exports